import { useState, useEffect } from "react";
import axios from "axios";
import { Input, Checkbox, Select, Button } from '@/components'
import { apiOptions, mobileOptions, businessOptions, revenueOptions, productsOptions } from '@/constant'
import { useMobile } from '@/hooks'
import "./style.scss"
import "./style.mobile.scss"
import toast from 'react-hot-toast'

const ContactUs = () => {
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [data, setData] = useState({
    name: "",
    email: "",
    companyName: "",
    phoneNumber: "",
    companyRole: "",
    businessType: "",
    exploreSolution: [],
    annualRevenue: "",
    usWarehouse: '',
  });

  const [status, setStatus] = useState<
    Partial<Record<keyof typeof data, boolean>>
  >({});

  const [ isMobile ] = useMobile()

  const handleChange = (field: keyof typeof data , value: string | string[]) => {
    if (Array.isArray(value)) {
      status[field] = !value.length;
    } else {
      status[field] = !value;
    }
    setData((pre) => ({
      ...pre,
      [field]: value,
    }));
  }

  const validate = () => {
    let pass = true
    let state: typeof status = {};
    (Object.keys(data) as (keyof typeof data)[]).forEach((field) => {
      let value = data[field];
      if (Array.isArray(value)) {
        state[field] = !value.length;
      } else {
        state[field] = !value;
      }
      if (state[field]) {
        pass = false;
      }
    });
    setStatus(state);
    return pass
  }

  const onSubmit = () => {
    if(loading) {
      return
    }
    if(!validate()) {
      return
    }
    toast.remove()
    setLoading(true)
      axios
        .post(
          "https://cloudstore.bybieyang.com/cloud-store/partner/submit",
          data,
          {
            timeout: 60000,
          }
        )
        .then(() => {
          toast.custom(() => {
            return <div className="toast-container">Submitted</div>;
          })
        })
        .catch((err) => {
          console.log(err)
        }).finally(() => {
          setLoading(false);
        });
  }

  return (
    <section className="contact-us-page">
      <div className="module-title">
        <h2
          className="contact-us-title"
        >
          Partner with Cloud Store
        </h2>
        <p className="contact-us-subtitle">
          We will contact you within one business day after submission. 
        </p>
      </div>
      <div className="module-form">
        <Input
          className="form-item"
          label="Name"
          value={data.name}
          onChange={(e) => handleChange("name", e.target.value)}
          error={status.name}
        />
        <Input
          className="form-item"
          label="Email"
          value={data.email}
          error={status.email}
          onChange={(e) => handleChange("email", e.target.value)}
        />
        <Input
          className="form-item"
          label="Company name"
          value={data.companyName}
          error={status.companyName}
          onChange={(e) => handleChange("companyName", e.target.value)}
        />
        <Input
          className="form-item"
          label="Phone Number"
          value={data.phoneNumber}
          error={status.phoneNumber}
          onChange={(e) => handleChange("phoneNumber", e.target.value)}
        />
        <Input
          className="form-item"
          label="Your role at the company"
          value={data.companyRole}
          error={status.companyRole}
          onChange={(e) => handleChange("companyRole", e.target.value)}
        />
        <Select
          className="business-type form-item"
          label="Business type"
          options={businessOptions}
          value={data.businessType}
          error={status.businessType}
          onChange={(e) => handleChange("businessType", e)}
        />
        <Checkbox
          className="form-item"
          options={isMobile ? mobileOptions : apiOptions}
          label="Which solution would you like to explore more?"
          value={data.exploreSolution}
          error={status.exploreSolution}
          onChange={(e) => handleChange("exploreSolution", e)}
        />
        <Select
          className="revenue form-item"
          label="What are your annual revenue?"
          options={revenueOptions}
          value={data.annualRevenue}
          error={status.annualRevenue}
          onChange={(e) => handleChange("annualRevenue", e)}
        />
        <Select
          options={productsOptions}
          className="products form-item"
          label="Do you have a US warehouse to deliver the products?"
          value={data.usWarehouse}
          error={status.usWarehouse}
          onChange={(e) => handleChange("usWarehouse", e)}
        />
        <Button className="action-button" icon={false} onClick={onSubmit}>
          Submit Enquiry
        </Button>
      </div>
    </section>
  );
}

export default ContactUs;